export default __webpack_public_path__ + "static/media/pink_base.9e79d487.png";